import React, { useEffect } from 'react';

import { useIsGreaterThanTabletLandscape } from '~/src/common/mediaQueries';
import { useIsLandscapeOrientation } from '~/src/common/mediaQueries/useIsLandscapeOrientation';

import { useMediaPlayer } from './MediaPlayerProvider';

export const FullscreenForSmallDevices: React.FC = () => {
  const { player } = useMediaPlayer();
  const isGreaterThanTabletLandscape = useIsGreaterThanTabletLandscape();
  const isLandscapeOrientation = useIsLandscapeOrientation();

  useEffect(() => {
    if (player !== null && isLandscapeOrientation && !isGreaterThanTabletLandscape) {
      player.posterImage.on('tap', () => {
        player.requestFullscreen();
      });
      player.bigPlayButton.on('tap', () => {
        player.requestFullscreen();
      });

      player.on('ended', () => {
        if (player.isFullscreen()) {
          player.exitFullscreen();
        }
      });
    }
  }, [isGreaterThanTabletLandscape, isLandscapeOrientation, player]);
  return null;
};
